import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { useAuth } from '@/composables/useAuth';
import '@pappers-fr/pappers-ui/dist/assets/styles/pi-module.css';
// Styles scopés des composants (fade-in/fade-out des tooltips et dropdowns notamment)
import '@pappers-fr/pappers-ui/dist/pi.css';
import './assets/main.css';

Office.onReady(async () => {
	await useAuth().initAuth();
	const app = createApp(App);
	app.use(createPinia());
	app.mount('#app');
});
